export default __webpack_public_path__ + "static/media/turn-left.107e43d3.svg";